import { useMemo } from 'react';
import { useSpotMarkets } from './useSpotMarkets';

export const useUniqueSpotMarkets = () => {
	const spotMarkets = useSpotMarkets();
	return useMemo(() => {
		return spotMarkets.filter(
			(market, index, self) =>
				index === self.findIndex((t) => t.mint.equals(market.mint))
		);
	}, [spotMarkets]);
};
